'use strict'

const IP_RANGES = [
  // 0.0.0.0 - 0.255.255.255
  '0(?:\\.\\d{1,3}){3}',
  // 10.0.0.0 - 10.255.255.255
  '10(?:\\.\\d{1,3}){3}',
  // 127.0.0.0 - 127.255.255.255
  '127(?:\\.\\d{1,3}){3}',
  // 169.254.1.0 - 169.254.254.255
  '169\\.254\\.(?:[1-9]|1?\\d\\d|2[0-4]\\d|25[0-4])\\.\\d{1,3}',
  // 172.16.0.0 - 172.31.255.255
  '172\\.(?:1[6-9]|2\\d|3[01])(?:\\.\\d{1,3}){2}',
  // 192.0.0.0 - 192.0.0.255, 192.0.2.0 - 192.0.2.255, 192.168.0.0 - 192.168.255.255
  '192\\.(?:0\\.0(?:\\.\\d{1,3})|0\\.2(?:\\.\\d{1,3})|168(?:\\.\\d{1,3}){2})',
  // 100.64.0.0 - 100.127.255.255
  '100\\.(?:6[4-9]|[7-9]\\d|1[01]\\d|12[0-7])(?:\\.\\d{1,3}){2}',
  // 198.18.0.0 - 198.19.255.255, 198.51.100.0 - 198.51.100.255
  '198\\.(?:1[89](?:\\.\\d{1,3}){2}|51\\.100(?:\\.\\d{1,3}))',
  // 203.0.113.0 - 203.0.113.255
  '203\\.0\\.113(?:\\.\\d{1,3})',
  // 224.0.0.0 - 239.255.255.255
  '22[4-9](?:\\.\\d{1,3}){3}|23[0-9](?:\\.\\d{1,3}){3}',
  // 240.0.0.0 - 255.255.255.255
  '24[0-9](?:\\.\\d{1,3}){3}|25[0-5](?:\\.\\d{1,3}){3}',
  // localhost in IPv4
  'localhost'
]

const regex = new RegExp(`^(${IP_RANGES.join('|')})$`)

module.exports = regex.test.bind(regex)
module.exports.regex = regex
